// import { DevArea } from "./dev";
import { AuthArea } from "./auth";
import { MainArea } from "./main";

import { MainLayout } from "../layouts";
import { MiscArea } from "./misc";
import { PreownedArea } from "./preowned";
import { REACT_APP_PREOWNED_ENABLED } from "../config";

export const Pages = {
  // dev: DevArea,
  auth: AuthArea.pages,
  main: MainArea.pages,
  preowned: PreownedArea.pages,
  misc: MiscArea.pages,
};
export default Pages;

export const AppArea = {
  areas: [
    // DevArea,
    AuthArea,
    MainArea,
    MiscArea,
    ...(REACT_APP_PREOWNED_ENABLED ? [PreownedArea] : []),
  ],
  layouts: {
    default: {
      path: "/",
      view: MainLayout,
    },
  },
};

// #region Typedefs
/** Page definition extend for this app.
 * @typedef {object} PageDefinitionEx
 * @property {string[]} [roles] Roles allowed to access the page.
 * @property {string} titleText Title of the page without the site name suffix.
 */
/** Combine PageDefinition and PageDefinitionEx to make Page.
 * @typedef {import("../lib/routing").PageDefinition & PageDefinitionEx} Page
 */
// #endregion
